import React, { useState, useEffect, useRef } from 'react';
import Breadcrumb from '../../components/common/breadcrumb';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import DataTables from '../commonComponent/DataTable/DataTables';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import { FrontDesk_URL } from '../../constant';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import LoadingButton from '../commonComponent/LoadingButton';
import Select from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

const ViewTemplateItems = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isbuttonLoading, setIsButtonLoading] = useState(false);
    const [viewtemplates, setViewTemplates] = useState([]);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [loginuserid, setLoginUserId] = useState(localStorage.LoggedInUser == undefined || localStorage.LoggedInUser == null ? "" : localStorage.LoggedInUser);
    const [logincentreid, setLoginCentreId] = useState(localStorage.CentreSNo == undefined || localStorage.CentreSNo == null ? "" : localStorage.CentreSNo);


    let reftempname = useRef();
    let refitemname = useRef();
    let refitemcode = useRef();

    useEffect(() => {
        GetViewTemplateItems();
    }, [])
    const paginationOptions = {
        sizePerPage: 50,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); }
    };
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div><span>{crntPageNO + rowIndex + 1}</span></div>
        </React.Fragment>
    }
    const columns = [{ dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
    // { dataField: 'TemplateName', text: 'Template Name', editable: false },
    // { dataField: 'IsScheme', text: 'Is Scheme', editable: false },
    { dataField: 'CategoryName', text: 'Category Name', editable: false },
    { dataField: 'TestName', text: 'Item Name', editable: false },
    { dataField: 'TestCode', text: 'Item Code', editable: false },
    { dataField: 'MRP', text: 'MRP', editable: false },
    { dataField: 'PartnerRate', text: 'Partner Rate', editable: false },
    // { dataField: 'IsActive', text: 'Is Active', editable: false },
    // { dataField: 'ActiveFrom', text: 'Active From', editable: false },
    // { dataField: 'ActiveTo', text: 'Active To', editable: false }
    ];
    const GetViewTemplateItems = async () => {
        setViewTemplates([]);
        setIsButtonLoading(true);
        var tempname = "0";//reftempname.current.value == null || reftempname.current.value == undefined || reftempname.current.value == "" ? "0" : reftempname.current.value;
        var itemname = refitemname.current.value == null || refitemname.current.value == undefined || refitemname.current.value == "" ? "0" : refitemname.current.value;
        var itemcode = refitemcode.current.value == null || refitemcode.current.value == undefined || refitemcode.current.value == "" ? "0" : refitemcode.current.value;
        let encodedName1 = encodeURIComponent(tempname);   
        let encodedName2 = encodeURIComponent(itemname);
        let encodedName3 = encodeURIComponent(itemcode);    
        var params = logincentreid + '/' + loginuserid + '/' + encodedName1 + '/' + encodedName2 + '/' + encodedName3
        try {
            let url = FrontDesk_URL + 'master/ViewTemplateItems/' + params
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    setIsButtonLoading(false);
                    if (data.Data != null) { setViewTemplates(data.Data) }
                    else { setViewTemplates([]); SweetAlert.fire("No record found"); }
                }
                else {
                    setIsButtonLoading(false);
                    APIError(data.Data, data.ErrorList.length === 0 ? "" : data.ErrorList[0].errorMsg);
                }
            }).catch(function (error) { setIsButtonLoading(false); if (error.response) { AxiosError(error.response.status); } });
        } catch (error) { setIsButtonLoading(false); APIError("-3"); }
    }
    const CallReload = async (e) => {
        e.preventDefault();
        window.location.reload(false);
    }
    const AxiosError = async (ErrorCode) => {
        if (ErrorCode === 400) { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }) }
        else if (ErrorCode === 401) { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }) }
        else if (ErrorCode === 403) { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }) }
        else if (ErrorCode === 404) { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }) }
        else if (ErrorCode === 500) { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }) }
        else if (ErrorCode === 503) { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }) }
    }
    const APIError = async (ErrorCode, ErrorMsg) => {
        if (ErrorCode === "-1") { SweetAlert.fire({ title: "Error is :", text: ErrorMsg, icon: "error" }) }
        else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }) }
    }
    return (
        <React.Fragment>
            <Breadcrumb title="View Template Items" parent="Master" />
            <Container fluid>
                <Form>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header className='pb-0'>
                                    <Card.Title>View Template Items</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Form>
                                        <Form.Row className='align-items-center'>
                                            {/*
                                            <Col lg={4} md={6}>
                                                <Form.Group>
                                                    <Form.Label>Template Name:</Form.Label>
                                                    <Form.Control type="text" id="tempname" name="visitid" ref={reftempname} />
                                                </Form.Group>
                                            </Col>
                                            */}
                                            <Col lg={6} md={6}>
                                                <Form.Group>
                                                    <Form.Label>Item Name:</Form.Label>
                                                    <Form.Control type="text" id="itemname" name="visitid" ref={refitemname} />
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} md={6}>
                                                <Form.Group>
                                                    <Form.Label>Item Code:</Form.Label>
                                                    <Form.Control type="text" id="itemcode" name="visitid" ref={refitemcode} />
                                                </Form.Group>
                                            </Col>
                                        </Form.Row>
                                        <Form.Row className='mt15'>
                                            <Col lg={12} md={12} className="text-center">
                                                {isbuttonLoading ? <LoadingButton variantName='primary' cssName="" /> : <Button variant='primary' className="mr-2" onClick={GetViewTemplateItems}>Search</Button>}
                                                <Button variant='secondary' onClick={(e) => CallReload(e)}>Refresh</Button>
                                            </Col>
                                        </Form.Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
                {/* {
                    viewtemplates == null || viewtemplates == [] || viewtemplates.length == 0 ? null : */}
                        <Form>
                            <Row>
                                <Col md={12}>
                                    <Card>
                                        <Card.Header className='pb-0'>
                                            <Card.Title>Template Rate List</Card.Title>
                                        </Card.Header>
                                        <Card.Body>
                                            <BootstrapTable
                                                keyField='TestName'
                                                data={viewtemplates}
                                                columns={columns}
                                                bootstrap4
                                                headerWrapperClasses="thead-light"
                                                bordered={false}
                                                noDataIndication={<NoRecordFounds />}
                                                pagination={paginationFactory(paginationOptions)}
                                            ></BootstrapTable>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Form>
                {/* } */}
            </Container>
            {
                isLoading ?
                    <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                    null
            }
        </React.Fragment >
    )
}

export default ViewTemplateItems;